<app-spinner></app-spinner>
<div class="login-container">
  <div class="left-pane">
    <div class="logo-block">
      <img src="/assets/img/login/logo.svg" alt="webtest logo" />
    </div>

    <div class="content-block">
      <h2>Login</h2>
      <p class="text-muted">Enter your email below to login to your account.</p>


      <form #loginForm="ngForm" (ngSubmit)="onSubmit()">
        <div class="text-center" *ngIf="isError">
          <em class="text-danger text-center">{{alert}}</em>
        </div>
        <!-- <div class="form-group mb-3">
        <label for="username" style="color: #092056; font-weight: 600;">Username</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="bg-white mr-2 ml-2"><img src="/assets/img/login/profile.png" /></span>
          </div>
          <input id="username" type="text" class="form-control" placeholder="Username/Email"
            [(ngModel)]="loginDetails.Username" name="username" required>
        </div>
      </div> -->
        <div class="form-group mb-3 p-0">
          <label for="password" style="color: #092056; font-weight: 600;">Username/Email</label>
          <div class="input-group p-0">
            <div class="input-group-prepend mr-1">
              <span class="bg-white mr-2 ml-2"><i class="fa fa-user"></i></span>
            </div>
            <input id="username" type="username" class="p-0" placeholder="Username/Email"
              [(ngModel)]="loginDetails.Username" name="username" required>
          </div>
        </div>

        <div class="form-group mb-3">
          <label for="password" style="color: #092056; font-weight: 600;">Password</label>
          <div class="d-flex">
            <div class="input-group p-0">
              <div class="input-group-prepend mr-1">
                <span class="bg-white mr-2 ml-2"><i class="fa fa-lock"></i></span>
              </div>`
              <input id="password" type="password" class="p-0" placeholder="Password"
                [(ngModel)]="loginDetails.Password" name="password" required>
              <div class="input-group-append align-items-center">
                <span *ngIf="!showPassword" class="mx-2 py-auto"><i class="fa fa-eye-slash"
                    (click)="togglePassword()"></i></span>
                <span *ngIf="showPassword" class="mx-2 py-auto"><i class="fa fa-eye"
                    (click)="togglePassword()"></i></span>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-end mb-2">
          <a routerLink="/forgotpassword" class="text-decoration-none">Forgot password?</a>
        </div>

        <div class="d-flex flex-column">
          <button type="submit" class="d-flex justify-content-center align-items-center btn login-btn px-4"
            [disabled]="!loginForm.valid">
            <span style=" width:fit-content ; margin: 0px auto">Login</span>
          </button>
          <div class="d-flex justify-content-between">
            <a routerLink="/monitor" target="_blank" class="mr-2 text-decoration-none">Monitor an Examination</a>
            <a routerLink="/register" class="text-decoration-none">Register as a new user</a>
          </div>


        </div>
      </form>
    </div>
  </div>


  <div class="right-pane">
    <div class="overlay-text">
      <h1>Welcome Back to WebTest — Online Testing Solution for Secure And Seamless Examinations</h1>
      <p>
        Log for live coverage of the examinations showing details such as candidates taking, completed and dropped tests
        with their
        number of attempts, device name, browser, operating system, IP address and location details.
      </p>
    </div>
  </div>
</div>